import { skipToken, useQuery } from '@tanstack/react-query';

import { Libraries } from '@air/api';
import { type Library, type LibraryWithPermissions, type Workspace } from '@air/api/types';

export const LIBRARY_KEY = '@plugin-ui/LIBRARY';

export const getLibraryKey = (params: UseLibraryParams) => {
  return [LIBRARY_KEY, params];
};

export type UseLibraryParams = {
  libraryId: Library['id'] | undefined;
  workspaceId: Workspace['id'] | undefined;
};

export const useLibrary = ({
  initialData,
  ...params
}: UseLibraryParams & { initialData?: LibraryWithPermissions | undefined }) => {
  const { libraryId, workspaceId } = params;

  return useQuery({
    initialData,
    queryFn:
      workspaceId && libraryId
        ? () =>
            Libraries.get({
              libraryId,
              workspaceId,
            })
        : skipToken,
    queryKey: getLibraryKey(params),
  });
};
